import React from 'react';
import { OptimizelyProvider } from '@optimizely/react-sdk';

var FeatureFlagProvider = function FeatureFlagProvider(props) {
  return /*#__PURE__*/React.createElement(OptimizelyProvider, {
    optimizely: props.featureFlagClient,
    user: props.user,
    timeout: props.timeout
  }, props.children);
};

export { FeatureFlagProvider };
